import type { SyntheticEvent } from 'react';

import type { SmartCardEventClickHandler } from '@atlaskit/editor-common/ui';

import { isExternalShareRequest } from '@confluence/external-share-utils';
import type { RoutesContextType } from '@confluence/route-manager';
import { getSpaTransitionHref } from '@confluence/route-manager';

import { isClickEventToOpenNewTab } from './isClickEventToOpenNewTab';
import { isExternalLink } from './isExternalLink';

export const smartCardEventHandler = (
	routesContext: Pick<RoutesContextType, 'matchRoute' | 'push'>,
	e: SyntheticEvent<HTMLAnchorElement>,
	url?: string,
) => {
	const spaTransitionHref = getSpaTransitionHref(e, routesContext);

	if (isExternalLink(url)) {
		e.preventDefault();
		window.open(url, '_blank', 'noopener, noreferrer');
	} else if (spaTransitionHref && spaTransitionHref === url) {
		e.preventDefault();
		routesContext.push(spaTransitionHref, isExternalShareRequest());
	} else {
		handleClick(e, url);
	}
};

/**
 * Copied from @atlaskit/smart-card and
 * packages/media/smart-card/src/view/CardWithUrl/component.tsx to handle click
 * on a smart card with a URL because @atlaskit/smart-card expects
 * SmartCardEventClickHandler to handle the event fully, doesn't allow the
 * SmartCardEventClickHandler to fall back to the default @atlaskit/smart-card
 * click handler.
 */
const handleClick: SmartCardEventClickHandler = (e, url) => {
	isClickEventToOpenNewTab(e, { shouldCheckIframe: true })
		? window.open(url, '_blank')
		: window.open(url, '_self');
};
